module.exports = __webpack_public_path__ + "img/sld_mfm_inv_15_t1_b1_dark.12c485dd.svg";